export enum OrderHandlingInstSource {
  /** FINRA OATS */
  FINRAOATS = 1,
  /** FIA Execution Source Code */
  FIAExecutionSourceCode = 2,
}
